import React from 'react';

import ChevronLeft from '@/assets/icon-chevron-left.svg?react';
import { scrollRootToTop } from '@/utils/ui';

import classes from './styles.module.scss';

type Theme =
    | 'primary'
    | 'textOnPrimary'
    | 'outlineOnPrimary'
    | 'outlineOnBackground'
    | 'primaryOnWhite'
    | 'blackOnWhite';
type Size = 'small' | 'medium' | 'large';
type ChevronType = 'left' | 'right';

interface Props extends React.HTMLAttributes<HTMLElement> {
    onclick?: () => void;
    extClasses?: string;
    type: Theme;
    size: Size;
    children: React.ReactNode;
    id?: string;
    style?: React.CSSProperties;
    disabled?: boolean;
    testId?: string;
    chevron?: ChevronType;
    disableScroll?: boolean;
}

export default function Button({
    children,
    style,
    onclick,
    extClasses,
    id,
    type,
    size,
    disabled,
    testId,
    chevron,
    disableScroll,
}: Props) {
    return (
        <button
            id={id}
            style={style}
            disabled={disabled}
            className={`${classes[type]} ${classes[size]} ${extClasses} ${
                chevron === 'left' && classes.chevronLeft
            }`}
            onClick={() => {
                if (onclick) {
                    onclick();
                }
                if (!disableScroll) {
                    scrollRootToTop();
                }
            }}
            role='ui-button'
            data-testid={testId}
        >
            {chevron === 'left' && <ChevronLeft />}
            {children}
        </button>
    );
}
